import { render, staticRenderFns } from "./EvrakIndirIslemDetayView.vue?vue&type=template&id=51736fb4&scoped=true"
import script from "./EvrakIndirIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./EvrakIndirIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51736fb4",
  null
  
)

export default component.exports